export default {
  CharQianFen: '‰',
  CharWanFen: '‱',
  SysSuc: 1,
  SysFail: 0,
  RoleRoot: 1,
  RoleAgent: 4,
  RoleReviewer: 6,
  RoleMch: 12,
  rolePath: role => {
    switch (role) {
      case 4:
        return 'agent';

      case 12:
        return 'mch';

      default:
        return '';
    }
  },
  formAdd: 1,
  formUpdate: 2,
  formQuery: 3,
  protocolPms: 'pms',
  //商户技术分账服务协议
  protocolPmc: 'pmc',
  //合作商合规经营承诺函
  protocolESign: 'pme',
  //e签宝线下
  protocolESignApi: 'pmeb',
  //e签宝api
  productVirtualAccount: 6,
  getProductRemark: (pl, key) => {
    for (const i in pl) {
      if (pl[i].id == key) return pl[i].remark;
    }

    return key;
  },
  getChannelRemark: (pl, key) => {
    for (const i in pl) {
      if (pl[i].key == key) return pl[i].remark;
    }

    return key;
  },
  getVBankKeyList: (pl, key) => {
    const kl = [];

    for (const i in pl) {
      if (pl[i].team == 'v-bank') {
        if (pl[i].key == key && pl[i].status == 1) {
          kl.push(pl[i]);
        }
      }
    }

    return kl;
  },
  getJoinTip: (tl, cnlTag, accountType) => {
    for (const i in tl) {
      if (tl[i].team == 'join-tip') {
        if (tl[i].key == cnlTag) {
          if (tl[i].remark == accountType) {
            return tl[i].val;
          }
        }
      }
    }

    return '';
  },
  getTransCost: (tl, cnlTag, transType) => {
    for (const i in tl) {
      if (tl[i].team == 'trans-cost') {
        if (tl[i].key == cnlTag) {
          if (tl[i].remark == transType) {
            return parseInt(tl[i].val);
          }
        }
      }
    }

    return 0;
  },
  regexPhone: val => {
    return /^[1][3,4,5,7,8,9][0-9]{9}$/.test(val);
  },
  regexEmail: val => {
    return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val);
  },
  regexFormatSpace: val => {
    //空格过滤
    return val.replace(/\s/g, '');
  },
  regexNumber: val => {
    //数字过滤
    return val.replace(/[^\d\.]/g, '');
  },
  AccountMchZero: 0,
  AccountMchComp: 1,
  AccountMchCompPerson: 2,
  AccountMchPerson: 3,
  IncomeEmpty: 0,
  IncomeEditing: 1,
  IncomeSubmitted: 2,
  IncomeFailed: 3,
  IncomeSuccess: 4,
  CardPerson: 1,
  CardComp: 2,
  CardVirtualComp: 3,
  CardWallet: 4,
  CardWhite: 5,
  //订单类型
  FOTZero: 0,
  FOTVirtualIn: 1,
  FOTVirtualOut: 2,
  FOTInsteadPay: 3,
  FOTWithdraw: 4,
  FOTInnerTrans: 5,
  FOTInnerSupplyTrans: 6,
  FOSupplyInstead: 7,
  FOSupplyWithdraw: 8,
  //订单状态
  FOSInit: 0,
  FOSSubmitted: 1,
  FOSSuc: 2,
  FOSFail: 3,
  FOSCancel: 4,
  cnlLianLian: 'lianlian',
  cnlYeePay: 'yeepay',
  cnlDinPay: 'dinpay',
  cnlSmb: 'smb',
  cnlFuIou: 'fuiou',
  cnlGrg: 'grgcloud',
  cnlInfoErr: 'err',
  cnlInfoSuc: 'suc',
  cnlInfoYpAgreementSign: 'yp_agreement_sign',
  cnlInfoYpModFeeSign: 'yp_mod_fee_sign',
  cnlInfoYpModPrdSign: 'yp_mod_prd_sign',
  cnlInfoYpVbSmsVerify: 'yp_vb_sm_verify',
  cnlInfoLLOpenSign: 'll_open_sign',
  //虚拟户签约
  cnlInfoLLLegSign: 'WAIT_SIGN',
  //法人签约
  cnlInfoLLAgreeSign: 'll_agree_sign',
  //法人签约
  cnlInfoCompAcctValid: 'comp_acct_valid',
  //对公账户资金验证
  cnlInfoFyActiveSign: 'fy_active_sign',
  //富管家开户签约链接 所有户都要
  cnlInfoFyAgentSendAudit: 'fy_agent_send_audit',
  //富友代理提交后 提审
  cnlInfoGegSaleAgentCompActive: 'grg_sa_cp_active',
  //grg 集采户 对公激活
  cnlInfoDpWaitRealName: 'dp_w_real_name',
  cnlInfoDpWaitLegSign: 'dp_sign',
  cnlInfoDpBankDoing: 'dp_bank_doing',
  cnlInfoDpBankVerify: 'dp_bank_verify',
  version: '1.5.8',
  //
  extraFromDpSwitchPersonBankCard: 'ef_dp_p_s_bk',
  extraFormLLCompInstead: 'ef_ll_cp_idp',
  extraFormPersonNewBindCard: 'ef_p_new_bk',
  extraFormMchSaveEncrypt: 'ef_m_s_encrypt',
  extraFormPersonCancelBindCard: 'ef_p_c_bk',
  extraFormGrgNewWhitePerson: 'ef_grg_nwp',
  extraFormInsteadWhiteAdd: 'ef_a_idpw'
};